import React, { Component } from "react";
import Banner from "../../../components/common/Banner";
import Header from "../../../components/common/Header";
import DepartmentSidebar from "../component/DepartmentSidebar";
import DepartmentAchievers from "../component/DepartmentAchievers";
import DepartmentNumbers from "../component/DepartmentNumbers";
import Footer from "../../../components/common/Footer";
import DepartmentVideo from "../component/DepartmentVideo";

export default class MCAAbout extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner
          title="Master of Computer Applications (MCA)"
          image="banners/department-mca.jpg"
        />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <DepartmentAchievers department="mca" />
                  <DepartmentNumbers
                    text1="Number of students on roll"
                    num1="318"
                    text2="Number of ranks since inception"
                    num2="22"
                    text3="Number of graduated batches"
                    num3="25"
                    text4="Current year offers"
                    num4="160"
                    text5="Number of publications"
                    num5="36"
                    text6="Average Placement (%) in last 5 years"
                    num6="75"
                  />
                  <div className="ttm-service-description">
                    <div className="row">
                      <div className="col-md-5">
                        <div className="ttm_single_image-wrapper">
                          <img
                            className="img-fluid"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/departments/mca/about-1.jpg"
                            }
                            alt="single-img-eighteen"
                          />
                        </div>
                      </div>
                      <div
                        className="col-md-7 justify"
                        style={{ margin: "auto" }}
                      >
                        <p>
                          MCA Department was established in 1997. The department
                          is having well qualified and experienced faculty
                          members. The department is affiliated to VTU and AICTE
                          has approved an intake of 180 Students. Our department
                          has bagged SIXTEEN university ranks with two gold
                          medals. We are proud that, we have received a research
                          grant from VGST. Our students are placed in very
                          reputed software industries including Infosys, WIPRO,
                          IBM, Microsoft, TCS, MindTree, Honeywell, Cognizant,
                          Accenture, Optum, Comviva etc., and conduct various
                          students’ personality development programs including
                        </p>
                      </div>
                    </div>
                    <div className="paddingtop-2">
                      <p>
                        Placement Activities Technical, Cultural, Soft skills,
                        etc. We are Proud to say that 140 offers and 105 got
                        placed during the academic year 2021-2022.
                      </p>
                    </div>
                  </div>
                </div>
                <DepartmentVideo department="mca" />
                <div className="section-title with-desc text-left clearfix">
                  <div className="section-title with-desc text-left clearfix paddingtop-2">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Vision</h4>
                    </div>
                    <p>
                      To transform young graduates into skilled computer
                      professionals to meet industrial and societal needs.
                    </p>
                    <br />
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Mission</h4>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To enhance the Teaching learning process to meet
                          quality education in the field of Computer
                          applications
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To impart the knowledge in current technologies to
                          meet the industrial needs
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To inculcate ethical values and leadership qualities
                          for the betterment of society
                        </span>
                      </li>
                    </ul>
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">
                        PROGRAM EDUCATIONAL OBJECTIVES (PEO's):
                      </h4>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To develop quality application software with
                          innovative ideas to meet the industrial requirements{" "}
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To imbibe the current technologies and to adopt in
                          computing profession as per the changing needs{" "}
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To progress in their career with leadership qualities
                          and ethical values that enhances self and societal
                          growth
                        </span>
                      </li>
                    </ul>
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">PROGRAM OUTCOMES (POs):</h4>
                    </div>

                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor"></i>
                        <span className="ttm-list-li-content">
                          <strong>Foundation Knowledge:</strong> Apply knowledge
                          of mathematics, programming logic and coding
                          fundamentals for solution architecture and problem
                          solving.
                        </span>
                      </li>

                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor"></i>
                        <span className="ttm-list-li-content">
                          <strong>Problem Analysis:</strong> Identify, review,
                          formulate and analyse problems for primarily focussing
                          on customer requirements using critical thinking
                          frameworks.
                        </span>
                      </li>

                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor"></i>
                        <span className="ttm-list-li-content">
                          <strong>Development of Solutions:</strong> Design,
                          develop and investigate problems with an innovative
                          approach for solutions incorporating ESG/SDG goals.
                        </span>
                      </li>

                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor"></i>
                        <span className="ttm-list-li-content">
                          <strong>Modern Tool Usage:</strong> Select, adapt and
                          apply modern computational tools such as development
                          of algorithms with an understanding of the limitations
                          including human biases.
                        </span>
                      </li>

                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor"></i>
                        <span className="ttm-list-li-content">
                          <strong>Individual and Teamwork:</strong> Function and
                          communicate effectively as an individual or a team
                          leader in diverse and multidisciplinary groups. Use
                          methodologies such as agile.
                        </span>
                      </li>

                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor"></i>
                        <span className="ttm-list-li-content">
                          <strong>Project Management and Finance:</strong> Use
                          the principles of project management such as
                          scheduling, work breakdown structure and be conversant
                          with the principles of Finance for profitable project
                          management.
                        </span>
                      </li>

                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor"></i>
                        <span className="ttm-list-li-content">
                          <strong>Ethics:</strong> Commit to professional ethics
                          in managing software projects with financial aspects.
                          Learn to use new technologies for cyber security and
                          insulate customers from malware.
                        </span>
                      </li>

                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor"></i>
                        <span className="ttm-list-li-content">
                          <strong>Life-long Learning:</strong> Change management
                          skills and the ability to learn, keep up with
                          contemporary technologies and ways of working.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DepartmentSidebar department="mca" />
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
